/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Homepage Reducer
 */

import { payloadReducer, trueReducer } from '@zcode/reducers'
import type { Homepage } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction } from 'redux-actions'
import type * as actions from '../actions'
import {
  RECEIVE_ADDRESS_LINKS,
  RECEIVE_BUILDING_LINKS,
  RECEIVE_LISTABLES,
  RECEIVE_LUXURY_LISTABLES,
  RECEIVE_NEW_LISTABLES,
  RECEIVE_PET_LISTABLES,
  RECEIVE_SPOTLIGHT_LISTABLES,
  RECEIVE_UTILITIES_INCLUDED_LISTABLES,
  SET_IS_LISTABLES_LOADING,
  SET_IS_SPOTLIGHT_LISTABLES_LOADING,
} from '../constants/index'

export type Actions = ExtractActions<Values<typeof actions>>

export const homepageReducer = combineReducers<Homepage, Actions>({
  addressLinks: handleAction<Homepage['addressLinks'], Actions, typeof RECEIVE_ADDRESS_LINKS>(
    RECEIVE_ADDRESS_LINKS,
    payloadReducer,
    []
  ),
  addressLinksLoaded: handleAction(RECEIVE_ADDRESS_LINKS, trueReducer, false),
  buildingLinks: handleAction<Homepage['buildingLinks'], Actions, typeof RECEIVE_BUILDING_LINKS>(
    RECEIVE_BUILDING_LINKS,
    payloadReducer,
    []
  ),
  buildingLinksLoaded: handleAction<
    Homepage['buildingLinksLoaded'],
    Actions,
    typeof RECEIVE_BUILDING_LINKS
  >(RECEIVE_BUILDING_LINKS, trueReducer, false),
  listables: handleAction<Homepage['listables'], Actions, typeof RECEIVE_LISTABLES>(
    RECEIVE_LISTABLES,
    payloadReducer,
    null
  ),
  newListables: handleAction<Homepage['newListables'], Actions, typeof RECEIVE_NEW_LISTABLES>(
    RECEIVE_NEW_LISTABLES,
    payloadReducer,
    null
  ),
  luxuryListables: handleAction<
    Homepage['luxuryListables'],
    Actions,
    typeof RECEIVE_LUXURY_LISTABLES
  >(RECEIVE_LUXURY_LISTABLES, payloadReducer, null),
  petListables: handleAction<Homepage['petListables'], Actions, typeof RECEIVE_PET_LISTABLES>(
    RECEIVE_PET_LISTABLES,
    payloadReducer,
    null
  ),
  utilitiesIncludedListables: handleAction<
    Homepage['utilitiesIncludedListables'],
    Actions,
    typeof RECEIVE_UTILITIES_INCLUDED_LISTABLES
  >(RECEIVE_UTILITIES_INCLUDED_LISTABLES, payloadReducer, null),
  spotlightListables: handleAction<
    Homepage['spotlightListables'],
    Actions,
    typeof RECEIVE_SPOTLIGHT_LISTABLES
  >(RECEIVE_SPOTLIGHT_LISTABLES, payloadReducer, []),
  isListablesLoading: handleAction<
    Homepage['isListablesLoading'],
    Actions,
    typeof SET_IS_LISTABLES_LOADING
  >(SET_IS_LISTABLES_LOADING, payloadReducer, true),
  isSpotlightListablesLoading: handleAction<
    Homepage['isSpotlightListablesLoading'],
    Actions,
    typeof SET_IS_SPOTLIGHT_LISTABLES_LOADING
  >(SET_IS_SPOTLIGHT_LISTABLES_LOADING, payloadReducer, true),
})
